import { Directive, ElementRef, HostBinding, HostListener, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImageViewerComponent } from '../image-viewer.component';

@Directive({
  selector: '[imageViewer]'
})
export class ImageViewerDirective {

  @HostBinding('style.cursor') private _cursor;

  @Input() src: any;
  @Input() alt: string;
  @Input('disabled')
  public set disabled(v: boolean) {
    this._disabled = v;
    if (v) {
      this._cursor = 'initial';
    }
  }
  @Input('imageViewer')
  public set customSrc(v: string) {
    if (!v) { return; }
    this._customSrc = v;
  }
  
  private _customSrc: string;
  private _disabled: boolean;


  constructor(
    private _elRef: ElementRef,
    private _dialog: MatDialog
  ) {
    if (this._elRef.nativeElement.tagName === 'IMG' || this._elRef.nativeElement.tagName === 'TIDY-PHOTO-NOTE'|| this._elRef.nativeElement.tagName === 'TIDY-IMAGE') {
      this._cursor = 'zoom-in';
    }
  }

  @HostListener('click')
  public viewImage(): void {

    if (this._disabled) { return; }

    this._dialog.open(
      ImageViewerComponent,
      {
        autoFocus: false,
        data: {
          src: this._customSrc || this.src,
          alt: this.alt
        },
        panelClass: 'ng-hacks-image-viewer',
        backdropClass: 'ng-hacks-image-viewer-backdrop'
      }
    );
  }
}
